import EventsRepository from '../../domain/repositories/EventsRepository';
import EventsDataStore from '../datastores/EventsDataStore';
import EventsDataStoreFactory from '../factories/EventsDataStoreFactory';

export default class EventsDataRepository implements EventsRepository {
  getEventsByStudentScroll(
    eventType: string,
    page: number,
    career: string,
    campus: string
  ) {
    const eventsDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventsDataStore.getEventsByStudentScroll(
      eventType,
      page,
      career,
      campus
    );
  }

  getEventDetail(eventId: number, campus: string, modality: string) {
    const eventsDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventsDataStore.getEventDetail(eventId, campus, modality);
  }

  getEventsByStudent(eventType: string) {
    const eventsDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventsDataStore.getEventsByStudent(eventType);
  }

  setEventInscription(eventId: number) {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.setEventInscription(eventId);
  }

  setEventUnsubscribe(eventId: number) {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.setEventUnsubscribe(eventId);
  }

  registerWaitingList(eventId: number, periodId: string) {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.registerWaitingList(eventId, periodId);
  }

  getPenalties(period: string) {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.getPenalties(period);
  }

  unregisterWaitingList(eventId: number) {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.unregisterWaitingList(eventId);
  }

  getOrganizer() {
    const eventDataStore: EventsDataStore = EventsDataStoreFactory.create();
    return eventDataStore.getOrganizer();
  }
}
